import { initialState } from '.';
import { RootState } from 'types';

import { createSelector } from '@reduxjs/toolkit';

const selectSlice = (state: RootState) => state.project || initialState;

export const selectProject = createSelector([selectSlice], state => state);
